
import LandingPage from "./pages/user"
import { RequireAuth } from "./context/auth-context"
import Userlayout from "./layouts/user-layout"
import { Children } from "react"
import AdminLayout from "./layouts/admin-layout"
import Products from "./pages/user/products"
import Sale from "./pages/user/sale"
import Cash from "./pages/user/cash/cash"
import Dashboard from "./pages/user"

const routes = [
    {
        path: "/",
        element: <RequireAuth><Userlayout /></RequireAuth>,
        children:[
            {
                path: "/",
                element: <Dashboard/>,
            },
            {
                path: "/products",
                element: <Products/>,
            },
            {
                path: "/sales",
                element: <Sale/>,
            },
            {
                path: "/cash",
                element: <Cash/>,
            },
            
        ]
    },
    
]

export default routes